// Protecciones anti-bot para los formularios de contacto.
// 1. Honeypot: un campo oculto que un humano nunca ve ni completa.
// 2. Trampa de tiempo: los bots envían el formulario casi al instante.
import { useCallback, useRef, useState } from 'react';

// Tiempo mínimo razonable para que una persona complete el formulario.
const MIN_FILL_MS = 3000;

const useAntiBot = () => {
  const [honeypot, setHoneypot] = useState('');
  const mountedAt = useRef(Date.now());

  const honeypotProps = {
    value: honeypot,
    onChange: (e) => setHoneypot(e.target.value),
  };

  const getAntiBotPayload = useCallback(
    () => ({ honeypot, elapsedMs: Date.now() - mountedAt.current }),
    [honeypot]
  );

  const looksLikeBot = useCallback(
    () => honeypot !== '' || Date.now() - mountedAt.current < MIN_FILL_MS,
    [honeypot]
  );

  return { honeypotProps, getAntiBotPayload, looksLikeBot };
};

export { useAntiBot, MIN_FILL_MS };
